import { observer } from 'mobx-react-lite';
import { useWindowSize } from 'src/core/hooks';
import { ProductProps } from './product.props';
import styles from './product.module.scss';

/**
 * <Product />
 */
const Product = observer<ProductProps>(({ product, locale }) => {
  const { width } = useWindowSize();

  const { name, taste, img, tars }: any = product;

  return (
    <div
      className={styles.product}
      style={{
        backgroundImage:
          width > 1149 ? `url(${img[locale]})` : `url(${img[locale]})`
      }}
    >
      <div className={styles.header}>
        {tars.split('|').map((el: string) => (
          <p className={styles.pointsText}>{el}</p>
        ))}
      </div>
      <div className={styles.btn_wrapper}>
        <h2
          className={styles.name}
          dangerouslySetInnerHTML={{ __html: name[locale] }}
        />
        <p className={styles.taste}>{taste[locale]}</p>
      </div>
    </div>
  );
});

export { Product };
